// replace.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: true
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, search: string, replacement: string): string {
    if (!value || !search) {
      return value; // Return original value if input is invalid
    }
    return value.replace(search, replacement); // Simple replace
    // For replacing all occurrences, use replaceAll:
    // return value.replaceAll(search, replacement);
  }
}